// notification.js
import { defineStore } from 'pinia'
import axios from 'axios'

export const useNotificationStore = defineStore('notification', {
    state: () => ({
        allNotification: [],
    }),
    actions: {
        async getAllNotification(filter) {
            try {
                const response = await axios.get('/notifications', { params: filter, noLoader: true })
                if (response.status === 200) {
                    this.allNotification = response.data.data
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async getNotification(filter) {
            try {
                const response = await axios.get('/notification', { params: filter })
                if (response.status === 200) {
                    // console.log('response', response);
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async getEmcNotification(filter) {
            try {
                const response = await axios.get('/notifications/emc', { params: filter })
                if (response.status === 200) {
                    // console.log('response', response);
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async readAllNotification(body) {
            try {
                const response = await axios.post('/notifications/read-all', body)
                // const response = await axios.post('/notifications/read-all', body, { noLoader: true })
                if (response.status === 200) {
                    // console.log('response', response);
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async deleteAllNotification() {
            try {
                const response = await axios.delete(`/notifications`)
                if (response.status === 200) {
                    // console.log('response', response);
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
        async deleteBulkNotification(body) {
            try {
                const response = await axios.delete(`/notifications/bulk`, { data: body })
                if (response.status === 200) {
                    // console.log('response', response);
                }
                return response;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
    }
})